import React, { useState } from "react";
import {
  Typography,
  Modal,
  Box,
  ImageListItem,
  Divider,
  Button,
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import Close from "../../../assets/icons/Close.svg";
import GreyDownArrow from "../../../assets/icons/GreyDownArrow.svg";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { addScreenAccessMasterList } from "../../../redux/actions/mastersAction";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  border: "1px solid #FFFFFF",
  boxShadow: 24,
  padding: "20px 0px 20px 0px",
  borderRadius: "12px",
  outline: "none",
};

const AddScreenAccessMasterModel = (Props) => {
  const dispatch = useDispatch();

  const [ScreenAccessName, SetScreenAccessName] = React.useState("");

  const handleChangeScreenAccessName = (event) => {
    SetScreenAccessName(event.target.value);
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    if (ScreenAccessName !== "") {
      dispatch(
        addScreenAccessMasterList({
          name: ScreenAccessName,
        })
      );
      Props.handleCloseAddScreenAccessModel();
    } else {
      toast.error("Please enter Screen Access Name");
    }
  };

  return (
    <Modal
      open={Props.isAddScreenAccessModel}
      onClose={() => Props.handleCloseAddScreenAccessModel}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box
          sx={{
            display: "flex",
            marginBottom: "20px",
          }}
        >
          <Box sx={{ width: "90%" }}>
            <Typography
              align="center"
              sx={{
                color: "#212121",
                fontSize: "22px",
                fontWeight: 500,
                position: "relative",
                left: "35px",
              }}
            >
              Add Screen Access
            </Typography>
          </Box>
          <Box
            sx={{
              width: "10%",
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              mr: 3,
            }}
          >
            <ImageListItem
              sx={{ cursor: "pointer", width: "15px" }}
              onClick={Props.handleCloseAddScreenAccessModel}
            >
              <img src={Close} alt="" />
            </ImageListItem>
          </Box>
        </Box>
        <Divider />
        <Box sx={{ padding: "20px" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: "10px",
              mb: "20px",
            }}
          >
            <TextField
              id="outlined-basic"
              variant="outlined"
              placeholder="Screen Name"
              type="text"
              value={ScreenAccessName}
              onChange={handleChangeScreenAccessName}
              sx={{
                width: "100%",
                borderRadius: "50px",
                backgroundColor: "#F3F6F9",
                borderRadius: "10px",
                border: "none",
                "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                  border: "0px solid #F3F6F9",
                  borderRadius: "10px",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none", 
                },
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          <Box
            sx={{
              marginTop: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "15px",
            }}
          >
            <Button
              // variant="contained"
              sx={{
                fontSize: "15px",
                border: "1px solid #26875C",
                fontWeight: 600,
                width: "8rem",
                // backgroundColor: "#26875C",
                padding: "10px 5px 10px 5px",
                borderRadius: "10px",
                textTransform: "capitalize",
                color: "#26875C",
                // ":hover": {
                //   backgroundColor: "#26875C",
                // },
              }}
              onClick={Props.handleCloseAddScreenAccessModel}
            >
              Cancel
            </Button>

            <Button
              // variant="contained"
              onClick={onSubmit}
              sx={{
                fontSize: "15px",
                fontWeight: 600,
                width: "8rem",
                border: "1px solid #26875C",
                backgroundColor: "#26875C",
                padding: "10px 5px 10px 5px",
                borderRadius: "10px",
                textTransform: "capitalize",
                color: "#FFFFFF",
                ":hover": {
                  backgroundColor: "#26875C",
                },
              }}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddScreenAccessMasterModel;
